import { api } from './api';

export async function getChallenges(filters?: any) {
  const { data } = await api.get(`challenge`, {
    params: { orderby: 'extra.order', q: `'extra.hidden':null,active:true${filters ? ',' + filters : ''}` },
  });
  if (!Array.isArray(data)) {
    return [];
  } else {
    return data.filter(item => item.techniques.includes('GT35'));
  }
}

export async function getChallengeHome(filters?: any) {
  const { data } = await api.get(`challenge`, {
    params: { orderby: 'extra.order', q: `'extra.hidden':null,active:true,'extra.quadrante':true` },
  });
  if (!Array.isArray(data)) {
    return [];
  } else {
    return data.filter(item => item.techniques.includes('GT35'));
  }
}

export async function getAllChallenges(filters?: any) {
  const { data } = await api.get(`challenge`, {
    params: { orderby: 'extra.order', reverse: true, q: "'extra.hidden':null,active:true" },
  });
  if (!Array.isArray(data)) {
    return [];
  } else {
    return data;
  }
}

export async function getChallengeUser(cycle?: string, perfil?: string) {
  const payload = { cycleId: !!cycle ? cycle : null, perfil: !!perfil ? perfil : null, technique: 'GT35' };
  const { data } = await api.post(`find/challenge`, payload);
  if (!Array.isArray(data)) {
    return [];
  } else {
    return data;
  }
}

export async function getBadgesUser(player: string) {
  const payload = { player, technique: 'GT02' };
  const { data } = await api.post(`find/get_badges`, payload);
  if (!Array.isArray(data)) {
    return [];
  } else {
    return data[0];
  }
}
